import { render, staticRenderFns } from "./SidebarWidget.vue?vue&type=template&id=fc9fb8d0&scoped=true&"
import script from "./SidebarWidget.vue?vue&type=script&lang=js&"
export * from "./SidebarWidget.vue?vue&type=script&lang=js&"
import style0 from "./SidebarWidget.vue?vue&type=style&index=0&id=fc9fb8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9fb8d0",
  null
  
)

export default component.exports